import {enum_NODE_ENV, enum_projectEnv_s} from "../../functions/src/shareCode/Share_S_Enum";
import {gv_fun_env} from "../../functions/src/shareCode/Share_Ass_GlobalVirables";


export const gv_env =  {
    localhost_b         : process.env.NODE_ENV === enum_NODE_ENV.development,
    storageDebugMode    : false
}

export const gv_strings = {

    height_topBar_mobile    : '40px',
    height_bottomBar_mobile : '50px',

    height_topBar_tablet    : '50px',
    height_bottomBar_tablet : '60px',

    height_topBar_laptop    : '58px',
    height_bottomBar_laptop : '0px',

    height_bottomBar_hide   : '0px',

    hebrewCode              : 'he',
}


export const gv_fonts = ['Arial', 'Times New Roman', 'Impact', 'Courier', 'Verdana', 'Georgia', 'Palatino', 'Garamond',
    'Bookman', 'Comic Sans MS', 'Lucida Console', 'Trebuchet MS', 'Arial Black', 'SuezOne Regular', 'SecularOne Regular', 'Montserrat', 'Roboto', 'OpenSans',
    "Helvetica Neue Condensed Bold", "Helvetica Neue Condensed", "Helvetica Med Cd Obl", "Helvetica Med Cd"
].sort()

// firebase_projectConfig
export const gv_FbConfig = () => {

    return ({
        [enum_projectEnv_s.tq_dev]: {
            domain: 'https://travelquestdev.firebaseapp.com',
            apiKey: "AIzaSyAvH1jZ78wHrAuhlVqXLyczc0kIOrrswpo",
            authDomain: "travelquestdev.firebaseapp.com",
            databaseURL: "https://travelquestdev.firebaseio.com",
            databaseURL_ongoing: "https://ongoing.firebaseio.com",
            projectId: "travelquestdev",
            projectId_ongoing: "ongoing",
            storage_belgium: "gs://travelquestdev-ongoing",
            storage_doc: "https://firestore.googleapis.com/v1/projects/travelquestdev/databases/(default)/documents",
            storageBucket: "travelquestdev.appspot.com",
            storageBucket_belgium: "travelquestdev-ongoing",
            functions: gv_fun_env.localServer_b ? "http://localhost:5001/travelquestdev/us-central1" : "https://us-central1-travelquestdev.cloudfunctions.net",
            messagingSenderId: "329212265305",
            appId: "1:329212265305:web:bca2c4c37a6b7059",
            translateKey: 'AIzaSyDVh1K3WjKaH0mWjgo6hMju2eFVVB9Kn1k'
        },
        [enum_projectEnv_s.tq_pro]: {
            domain: 'https://TravelQuest.xyz',
            apiKey: "AIzaSyCagZBk2Vwq7TBZu1JNahNHKCFFHgDIs7w",
            authDomain: "travelquest-da6b2.firebaseapp.com",
            databaseURL: "https://travelquest-da6b2.firebaseio.com",
            databaseURL_ongoing: "https://travelquest-searchquest.firebaseio.com",
            projectId: "travelquest-da6b2",
            projectId_ongoing: "travelquest-searchquest",
            storage_belgium: "gs://travelquest-da6b2",
            storage_doc: "https://firestore.googleapis.com/v1/projects/travelquest-da6b2/databases/(default)/documents",
            storageBucket: "travelquest-da6b2.appspot.com",
            storageBucket_belgium: "travelquest-da6b2",
            functions: gv_fun_env.localServer_b ? "http://localhost:5001/travelquest-da6b2/us-central1" : "https://us-central1-travelquest-da6b2.cloudfunctions.net",
            messagingSenderId: "478048304316",
            appId: "1:478048304316:web:68fc893af5ea6e73",

            translateKey: 'AIzaSyAmiAxPEhYdAAcipaRi2jP4rUrEBSWpw48'
        },
        [enum_projectEnv_s.tq_nice]: {
            domain: 'https://travelquestnice.web.app/',
            apiKey: "AIzaSyBJ18HVxHd2xf14AmQfDocNJodqUc1PDn0",
            authDomain: "travelquestnice.firebaseapp.com",
            databaseURL: "https://travelquestnice-default-rtdb.europe-west1.firebasedatabase.app",
            databaseURL_ongoing: "https://travelquestniceongoing-3a763.firebaseio.com",
            projectId: "travelquestnice",
            projectId_ongoing: "travelquestniceongoing-3a763",
            storage_belgium: "gs://travelquestnice.appspot.com",
            storage_doc: "https://firestore.googleapis.com/v1/projects/travelquestnice/databases/(default)/documents",
            storageBucket: "travelquestnice.appspot.com",
            functions: "https://us-central1-travelquest-da6b2.cloudfunctions.net",
            messagingSenderId: "384849722072",
            appId: "1:384849722072:web:5bfc0a7245e1b43c15f5ad",
            measurementId: "G-4G34XXMNN4"
        }
    }[gv_fun_env.currentProject_e])
}

const domain_s = gv_env.localhost_b ? 'http://localhost:8080' : gv_FbConfig().domain

export const gv_urls = {

    tq_basicUrl             : domain_s,

    googleStore             : 'https://play.google.com/store/apps/details?id=com.travelandquest.pro',
    appStore                : 'https://apps.apple.com/us/app/travel-and-quest/id1486135481#?platform=iphone',

    icredit_IPN             : 'https://us-central1-travelquest-da6b2.cloudfunctions.net/icredit_IPN',
    icredit_IPNFailure      : 'https://us-central1-travelquest-da6b2.cloudfunctions.net/icredit_IPNFailure',

    icredit_IPN_dev         : 'https://us-central1-travelquestdev.cloudfunctions.net/icredit_IPN',
    icredit_IPNFailure_dev  : 'https://us-central1-travelquestdev.cloudfunctions.net/icredit_IPNFailure',


    whatsApp_share_prefix   : 'https://wa.me/?text=',
    twitter_share_prefix    : 'https://twitter.com/intent/tweet?text=',
    email_share_prefix      : 'mailto:?subject=I wanted you to see this site&amp;body=',
    gmail_share_prefix      : 'https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=youremail@gmail.com&body=',

    chrome_prefix           : 'googlechrome://navigate?url=',
    chromeIos_prefix        : 'googlechrome://',

}

export const gv_colorsLite = ['#faebd7', '#d4c1c5', '#b0e0e6',
    '#ffb6b9', '#ca91de', '#d9efcb', '#4c988c', '#da6d7f', '#3498DB',
    '#ffffff', '#000000'
]

export const gv_emoji = [
    '😀','😂','😅','😄','😉','😋','😎','😍','😘','🤗','🤔','😲','😳','😇','🤴','👸','👳','🏃',
    '🤞🏽','🤘🏽','👍','👌','👏','✍🏽','🙌🏼','💖','💙','💚','💛','💝','💗','💥','💫','👑','💎','🦊',
    '🦁','🐎','🦄','🐥','💐','🍄','🏠','🚂','⏱', '⏳','🚀','⭐','🌧','⚡','🔥','🎉','🏆','🎁',
    '🏅','📣','💡','🔦','💰','📝','⚔️','🏁','🚩'
]

export const gv_zIndex = {

    // ======= views ===========
    app_splashScreen                : 15,
    app_globalNotification          : 10,
    app_acceptTermsNotification     : 5,
    app_globalNotification_closeImg : 3,
    app_bottomBar                   : 5,
    app_topBar                      : 6,
    app_newVersionMsg               : 6,



    ongoing_cards_navBarBtns        : 1,
    ongoing_map_btns                : 3,


    player_order_btn                : 1,
    player_store_chat                      : 2,


    // ======= components =========
    tqPopup                         : 9,
    tqPopup_closeImage              : 3,

    tqTabs_notification             : 3,
    tqTabs_mobileMenu               : 1,

    tqLeafLet_map                   : 0,
    tqLeafLet_btns                  : 2,

    tqChat_notification             : 1,
    fullScreenImgCloseBtn           : 5,

    tqQuestExploreHeader_btns       : 2,

    tqDropDown       : 1,
    tqDropDown_options_mobile       : 6,
    tqNotificationContainer_notification : 5,

}
